import React, { useCallback, useContext } from 'react';
import { navigate } from 'gatsby';
import {
  Box,
  AspectRatio,
  Image,
  ListItem,
  UnorderedList
} from '@chakra-ui/react';
import dataLayerPush from '@helpers/dataLayerPush';
import { LocaleContext } from '@helpers/LocaleProvider';

const LocaleList = () => {
  const { locale, locales } = useContext(LocaleContext);

  // Sort locales alphabetically by the name value
  const localesSortedByName = locales
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name));

  const flags = require.context(`../../assets/images/flags`, true, /\.svg$/);
  const handleLocationChange = useCallback((langcode) => {
    navigate(`/${langcode}`);
    dataLayerPush({
      event: `location_link`,
      interaction: {
        click_text: `Change location`,
        location: langcode
      }
    });
  }, []);
  return (
    <UnorderedList listStyleType="none" ml={0} mb={0}>
      {localesSortedByName.map((localeItem) => {
        const isCurrentLocale = localeItem.code === locale;
        return (
          <ListItem
            key={localeItem.code}
            as="button"
            display="flex"
            alignItems="center"
            width="100%"
            p={2}
            mb={1}
            mr={0}
            color={isCurrentLocale ? `white` : `milka.primary.dark-purple`}
            fontFamily="heading"
            fontSize="sm"
            textTransform="uppercase"
            backgroundColor={
              isCurrentLocale ? `milka.primary.dark-purple` : `transparent`
            }
            cursor="pointer"
            onClick={() => handleLocationChange(localeItem.code)}
            _hover={{
              color: `milka.primary.dark-purple`,
              backgroundColor: `milka.primary.lilac-muted`
            }}>
            <AspectRatio
              boxSize="1rem"
              ratio="1"
              borderRadius="full"
              border="1px solid white"
              mr={1}
              overflow="hidden">
              <Image
                src={flags(`./${localeItem.code}.svg`).default}
                alt={localeItem.name}
              />
            </AspectRatio>
            <Box as="span">{localeItem.name}</Box>
          </ListItem>
        );
      })}
    </UnorderedList>
  );
};

export default LocaleList;
